import React, { ReactElement } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { AccreditationStatus } from '../../shared-types'

type FormFieldProps = {
  field: any
}

let statusOptions: { value: AccreditationStatus; label: string }[] = [
  { value: 'Draft', label: 'Draft' },
  { value: 'Submitted', label: 'Submitted' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
]

export let StatusField = ({ field }: FormFieldProps): ReactElement => (
  <FormControl fullWidth required>
    <InputLabel>Status</InputLabel>
    <Select
      value={field.state.value}
      label="Status"
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      sx={{ bgcolor: 'background.paperDark' }}
    >
      {statusOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)
